import React from 'react';
import { Segment } from 'semantic-ui-react';

//IMAGES
import CotalityLogo from '../../../image/CotalityLogo-footer.svg';

export default function Footer() {

    function redirectToURL(link) {
        window.open(link, '_blank', 'noopener noreferrer');
    }
    
    return (
        <footer id="footer" className="footer">
            <Segment inverted>
                <img src={CotalityLogo} alt="Cotality" className="footer-logo" onClick={() => {
                    redirectToURL('https://www.cotality.com/au/corestore')
                    ;
                }}/>
                <div>
                    <p className="no-margin">
                        <small>&copy; 2025 RP Data Pty Ltd t/a Cotality (ABN 67 087 759 171). All rights reserved. </small>
                    </p>
                    <p className="no-margin">
                        <small>
                            <a 
                                className="white-link" 
                                id="privacy-policy"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.cotality.com/au/legal/privacy"
                            >
                          Privacy Policy
                            </a> |
                            <a 
                                className="white-link" 
                                id="general-terms"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.cotality.com/au/legal/terms-conditions"
                            >
                          &nbsp;General Terms & Conditions
                            </a> |
                            <a 
                                className="white-link"
                                id="website-terms" 
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.cotality.com/au/legal/website-terms-of-use"
                            >
                          &nbsp;Website Terms of Use
                            </a> |
                            <a 
                                className="white-link"
                                id="data-code-of-conduct" 
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.cotality.com/au/legal/data-code-of-conduct"
                            >
                          &nbsp;Data Code of Conduct
                            </a> |
                            <a 
                                className="white-link"
                                id="disclaimer" 
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.cotality.com/au/legal/disclaimers"
                            >
                          &nbsp;Disclaimer
                            </a>
                        </small>
                    </p>
                </div>
            </Segment>
        </footer>
      
    );
}
